import { render, staticRenderFns } from "./AppPage.vue?vue&type=template&id=5739a65e&scoped=true"
import script from "./AppPage.vue?vue&type=script&lang=js"
export * from "./AppPage.vue?vue&type=script&lang=js"
import style0 from "./AppPage.vue?vue&type=style&index=0&id=5739a65e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5739a65e",
  null
  
)

export default component.exports